module.exports = __webpack_public_path__ + "61da357e8c8395e28c63ad95a2d58dc5.jpg";